<div class="sidemenu-layout {{impersonatedUser ? 'impersonated-user' : ''}}" fxLayout="column">
  <div class="header">
    <div class="header-1">
      <div class="header-2">
        <topmenu
          [gitTagOrVersion]="gitTagOrVersion"
          [whitelabelServiceEventObservable]="whitelevelServiceEventObserver"
          (events)="onTopMenuEvent($event)">
        </topmenu>
      </div>
    </div>
  </div>
  <div class="body"
    fxLayout="row"
    fxLayoutAlign="center top">
    <div class="body-1">
      <div class="body-2">
        <mat-sidenav-container class="sidenav-container">
          <mat-sidenav [fixedInViewport]="true"
            [fixedTopGap]="sideNavGap"
            #sidenav="matSidenav"
            [mode]="mode === 'Mobile' ? 'over' : 'side'"
            [opened]="true"
            [disableClose]="mode === 'Mobile' ? 'false' : 'true'"
          >
            <div fxFlex="columns">
              <div class="sidenav hide-scrollbar">
                <sidemenu [user]="user"
                  [unreadNotificationsCountObservable]="unreadNotificationsCountObservable"
                  (menuTypeEvent)="onSidemenuEvents2($event)"
                  [portalThemeObservable]="portalThemeObservable"
                  [changePortalThemeFn]="changePortalThemeFn"
                  [heartbeatObservable]="heartbeatObservable"
                  [getAllNotificationsFn]="getAllNotificationsFn"
                  [dynabotEnabled]="dynabotEnabled"
                  (events)="onSidemenuEvents($event)"
                  >
                </sidemenu>
              </div>
            </div>
          </mat-sidenav>
          <mat-sidenav-content class="hide-scrollbar">
            <div>
              @if (mode === 'Mobile') {
                <div [matTooltip]="'Toggle sidemenu'">
                  <mat-icon class="expand-sidemenu-icon" (click)="matSidenav.toggle()">reorder</mat-icon>
                </div>
              }
              <error-notification2></error-notification2>
              <router-outlet></router-outlet>
            </div>
          </mat-sidenav-content>
        </mat-sidenav-container>
      </div>
    </div>
  </div>
  @if (dynabotEnabled) {
    <dynabot-widget
      [applicationId]="dynabotApplicationId"
      [sendDynabotMessageFn]="sendDynabotMessageFn">
    </dynabot-widget>
  }
  @if (impersonatedUser) {
    <div class="floating-footer pos-{{footerPosition}}">
      <div class="floating-footer-content" (mouseenter)="onHoverImpersonation(true)" (mouseleave)="onHoverImpersonation(false)">
        @if (footerPosition !== 1) {
          <div class="arrow-button left-arrow" (click)="changeFooterPosition(-1)">
            <mat-icon>arrow_left</mat-icon>
          </div>
        }
        @if (footerPosition === 2) {
          <span>Currently Impersonating: {{ impersonatedUser.GivenName + ' ' + impersonatedUser.FamilyName }} ({{ impersonatedUser.Email }})</span>
        } @else {
          <span>Impersonating: {{ impersonatedUser.GivenName + ' ' + impersonatedUser.FamilyName }}</span>
        }
        <span class="exit-impersonation" (click)="exitImpersonation()">
          <mat-icon>exit_to_app</mat-icon>
          <span>Exit</span>
        </span> 
        @if (footerPosition !== 3) {
          <div class="arrow-button right-arrow" (click)="changeFooterPosition(1)">
            <mat-icon>arrow_right</mat-icon>
          </div>
        }
      </div>
    </div>
  }
</div>